// if any step has all false showbooleans, remove it as a step so the empty step doesn't show up in the form
const filterByShowBoolean = (steps: any) => {
  return steps.filter(({ fields }: any) => {
    return fields.reduce((reductionBoolean: boolean, { showBoolean }: any) => {
      return reductionBoolean || showBoolean;
    }, false);
  });
};

export default filterByShowBoolean;
try {
    // @ts-ignore
    filterByShowBoolean.displayName = "filterByShowBoolean";
    // @ts-ignore
    filterByShowBoolean.__docgenInfo = { "description": "", "displayName": "filterByShowBoolean", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/stepContainer/dataTransform/filterByShowBoolean.ts#filterByShowBoolean"] = { docgenInfo: filterByShowBoolean.__docgenInfo, name: "filterByShowBoolean", path: "src/containers/stepContainer/dataTransform/filterByShowBoolean.ts#filterByShowBoolean" };
}
catch (__react_docgen_typescript_loader_error) { }